import React, { FunctionComponent } from 'react';

import BaseFooter from '@gojob/ui-bits/Footer';
import Social from '@gojob/ui-bits/Footer/Social';
import { graphql, useStaticQuery } from 'gatsby';

import Section from 'src/components/Footer/Section';
import { Footer as FooterType } from 'src/types/gojob';

const FooterLinkQuery = graphql`
  query {
    sanityFooter {
      sections {
        title
        links {
          text
          href
          id: html_id
          internalRef: ref {
            ... on SanityArticle {
              slug {
                current
              }
            }
            ... on SanityCategory {
              slug {
                current
              }
            }
            ... on SanityPage {
              slug {
                current
              }
            }
          }
        }
      }
      socialLinks: social {
        facebookLink
        instagramLink
        twitterLink
        linkedInLink
      }
    }
  }
`;

const Footer: FunctionComponent = () => {
  const { sanityFooter } = useStaticQuery<{ sanityFooter: FooterType }>(FooterLinkQuery);

  return (
    <BaseFooter css={{ width: '100%' }}>
      {sanityFooter?.sections?.map((section, index) => {
        return <Section key={index} {...section} />;
      })}
      <Social socialLinks={sanityFooter?.socialLinks || {}} />
    </BaseFooter>
  );
};

export default Footer;
